import AttachmentsGallery from './attachments-gallery';

export default AttachmentsGallery;
